import React from 'react';

import useUser from 'hooks/useUser';

import { Trans, useTranslation } from 'react-i18next';
import parsePhoneNumberFromString from 'libphonenumber-js';

import Checkbox from 'shared/components/inputs/Checkbox/Checkbox';
import TooltipText from 'shared/components/TooltipText/TooltipText';
import { LegalBodyCheckboxContainer, LegalBodyTextWrapper, StrongText } from './LegalBody.styles';
import { Button } from '../../../../Button/Button';
import { SmsOptInPolicySubText } from '../Shared/SubText/SmsOptInPolicySubText';
import {
  BodyText,
  SmsOptInModalBodyContainer,
  SmsOptInModalFooterContainer,
} from '../Shared/styles';

type Props = {
  handleCloseModal: () => void;
  handleSendPhoneVerificationCode: () => void;
  phoneNumber: string | undefined;
};

export function LegalBody({
  handleCloseModal,
  handleSendPhoneVerificationCode,
  phoneNumber,
}: Props) {
  const [optInChecked, setOptInChecked] = React.useState(false);
  const [optInError, setOptInError] = React.useState<string | undefined>();
  const { selectedAgreement } = useUser();

  const { t } = useTranslation();
  const handleOptInChange = () => {
    setOptInChecked((prev) => {
      const newVal = !prev;
      if (newVal) {
        setOptInError(undefined);
      }
      return newVal;
    });
  };
  const handleOptInClick = () => {
    if (!optInChecked) {
      setOptInError(t('account.smsOptIn.legalModal.checkboxError'));
      return;
    }
    handleSendPhoneVerificationCode();
  };
  return (
    <>
      <SmsOptInModalBodyContainer>
        <LegalBodyTextWrapper>
          <BodyText as="p">{t('account.smsOptIn.legalModal.body')}</BodyText>
        </LegalBodyTextWrapper>
        <LegalBodyCheckboxContainer>
          <Checkbox
            isChecked={optInChecked}
            isRequired
            onChange={handleOptInChange}
            text={
              <BodyText as="p" $margin="0 0 0 28px">
                <Trans
                  i18nKey="account.smsOptIn.legalModal.checkbox"
                  components={{
                    strong: <StrongText as="p" />,
                  }}
                  values={{
                    phoneNumber: phoneNumber
                      ? parsePhoneNumberFromString(phoneNumber, 'US')?.formatNational()
                      : '',
                  }}
                />
                <TooltipText
                  id="houseTooltip"
                  content={
                    selectedAgreement?.pto_date
                      ? t('account.smsOptIn.legalModal.tooltipPostPto')
                      : t('account.smsOptIn.legalModal.tooltipPrePto')
                  }
                  place="bottom"
                  $margin="0 0 -2px 0"
                  $maxWidth="220px"
                />
              </BodyText>
            }
            error={!!optInError}
            hint={optInError}
          />
        </LegalBodyCheckboxContainer>

        <SmsOptInPolicySubText />
      </SmsOptInModalBodyContainer>
      <SmsOptInModalFooterContainer>
        <Button
          styleVariant="tertiary"
          label={t('account.smsOptIn.legalModal.notNow')}
          onClick={handleCloseModal}
        />
        <Button
          styleVariant="primary"
          label={t('account.smsOptIn.legalModal.optIn')}
          onClick={handleOptInClick}
        />
      </SmsOptInModalFooterContainer>
    </>
  );
}
export default LegalBody;
